import React, { useState, useEffect } from 'react';

const NewsPage = () => {
  const [categorizedNews, setCategorizedNews] = useState([]);
  const [error, setError] = useState(null);

  const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }

  useEffect(() => {
    const fetchNews = async () => {
      try {
        // Fetch all published news events
        const newsResponse = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/news-events?status=published`);
        if (!newsResponse.ok) {
          throw new Error('Failed to fetch news');
        }
        const newsData = await newsResponse.json();
        const events = newsData.events;

        // Group events by category
        const groupedByCategory = events.reduce((acc, event) => {
          const categoryName = event.category?.name || 'Uncategorized';
          if (!acc[categoryName]) {
            acc[categoryName] = {
              id: event.category?.id || categoryName,
              name: categoryName,
              events: [],
            };
          }
          acc[categoryName].events.push(event);
          return acc;
        }, {});

        setCategorizedNews(Object.values(groupedByCategory));

      } catch (error) {
        setError(error.message);
      }
    };

    fetchNews();
  }, []);

  return (
    <div className="min-h-screen pt-40 bg-gray-100 font-poppins py-12">
      <div className="container mx-auto">
        <h1 className="text-4xl font-bold text-center text-[#364A9A] mb-12 font-poppins">News & Events</h1>
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
        {categorizedNews.length === 0 && !error && (
          <p className="text-center text-gray-500 text-sm sm:text-base">No news for now. Check back later.</p>
        )}
        {categorizedNews.map(category => (
          <div key={category.id} className="mb-10 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#364A9A] mb-4 sm:mb-6 font-poppins">{category.name}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {category.events.map((event) => (
                <div key={event.id} className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-1 transition-transform duration-300">
                  {event.images && event.images.length > 0 && (
                    <img src={`http://localhost:5000${event.images[0].imageUrl}`} alt={event.title} className="w-full h-40 sm:h-48 object-cover" />
                  )}
                  <div className="p-4 sm:p-6">
                    <h2 className="text-xl sm:text-2xl font-bold text-[#364A9A] mb-1 sm:mb-2 font-poppins">{event.title}</h2>
                    <p className="text-gray-500 text-xs sm:text-sm mb-2 sm:mb-3">{new Date(event.publishedDate).toLocaleDateString()}</p>
                    <p className="text-gray-700 text-sm sm:text-base mb-3 sm:mb-4">{stripHtml(event.content).substring(0, 150)}...</p>
                    <a href={`/news/${event.id}`} className="text-[#364A9A] font-semibold hover:underline text-sm sm:text-base">
                      Read More
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsPage;
